// extracted by mini-css-extract-plugin
export default {"container":"ScatterGraph_container__l7kS4","chart":"ScatterGraph_chart__Lrmyt"};